import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import NotificationBell from "@/components/NotificationBell";
import { LayoutDashboard, Users, ListTodo, Megaphone, MessageCircle, Ticket, Gift, Lightbulb, LogOut, ArrowLeft } from "lucide-react";

const items = [
  { to: "/admin", end: true, label: "Overview", icon: LayoutDashboard, testid: "admin-nav-overview" },
  { to: "/admin/athletes", label: "Athletes", icon: Users, testid: "admin-nav-athletes" },
  { to: "/admin/programs", label: "Programs", icon: ListTodo, testid: "admin-nav-programs" },
  { to: "/admin/codes", label: "Codes", icon: Ticket, testid: "admin-nav-codes" },
  { to: "/admin/referrals", label: "Referrals", icon: Gift, testid: "admin-nav-referrals" },
  { to: "/admin/tips", label: "Tips", icon: Lightbulb, testid: "admin-nav-tips" },
  { to: "/admin/messages", label: "Messages", icon: MessageCircle, testid: "admin-nav-messages" },
  { to: "/admin/broadcast", label: "Broadcast", icon: Megaphone, testid: "admin-nav-broadcast" },
];

export default function AdminLayout() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#070707] text-white" data-testid="admin-layout">
      <header className="sticky top-0 z-30 bg-[#070707]/95 backdrop-blur border-b border-[#1f1f1f]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 h-14 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <button onClick={() => navigate("/app/dashboard")} className="text-[#888] hover:text-white" data-testid="admin-back-to-app"><ArrowLeft className="w-4 h-4" /></button>
            <span className="font-display text-xl tracking-wider">COACH JP · <span className="text-[#d7ff00]">ADMIN</span></span>
          </div>
          <div className="flex items-center gap-1">
            <NotificationBell variant="admin" />
            <button onClick={logout} className="text-[#888] hover:text-white p-2" data-testid="admin-logout"><LogOut className="w-4 h-4" /></button>
          </div>
        </div>
        <nav className="border-t border-[#1f1f1f]">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 flex gap-1 overflow-x-auto hide-scrollbar">
            {items.map(it => {
              const Icon = it.icon;
              return (
                <NavLink key={it.to} to={it.to} end={it.end} data-testid={it.testid}
                  className={({ isActive }) => `inline-flex items-center gap-2 px-4 py-3 text-xs font-mono-jp uppercase tracking-widest ${isActive ? "text-[#d7ff00] border-b-2 border-[#d7ff00]" : "text-[#888] hover:text-white"}`}>
                  <Icon className="w-3.5 h-3.5" /> {it.label}
                </NavLink>
              );
            })}
          </div>
        </nav>
      </header>
      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-6 fade-in"><Outlet /></main>
    </div>
  );
}
